import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addBillingNote } from '../api/AddBillingNote';
import type { BillingNoteInput } from '../types/BillingNoteInput';

interface AddBillingNoteParams {
  billingUuid: string;
  note: BillingNoteInput;
}

export const useAddBillingNote = () => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: ({ billingUuid, note }: AddBillingNoteParams) =>
      addBillingNote(billingUuid, note),
    onSuccess: async (_, { billingUuid }) => {
      await queryClient.invalidateQueries({
        queryKey: ['billing-notes', billingUuid],
      });
      await queryClient.invalidateQueries({ queryKey: ['billings'] });
    },
  });

  return { addNote: mutate, isPending };
};
